import { DialogContent, Stack } from "@mui/material"
import { DialogActions, DialogHandler, DialogTitle, TextField, Typography } from "@cakemail-org/ui-components-v2"
import { t } from "i18next"
import { ChangeEvent, KeyboardEvent, KeyboardEventHandler, MouseEvent, useLayoutEffect, useRef, useState } from "react"
import "./styles.scss"
import { TDeleteDialogContent, TShowDeleteDialogPromise } from "./types"

export async function showDeleteDialog({ name, resourceKey, validationWordKey }: { name: string, resourceKey: string, validationWordKey?: string }): Promise<TShowDeleteDialogPromise> {
    validationWordKey = !validationWordKey ? "input-validation-key-delete" : validationWordKey
    return new Promise((resolve, reject) => {
        DialogHandler.show({
            content: <DeleteDialogContent resolve={resolve} reject={reject} name={name} resourceKey={resourceKey} validationWordKey={validationWordKey} />,
            managedByContent: true
        })
    })
}

function DeleteDialogContent({ resolve, reject, name, resourceKey, validationWordKey }: TDeleteDialogContent) {
    const [value, setValue] = useState<string>()
    const [error, setError] = useState<boolean>()
    const validationKey = useRef(t(validationWordKey))

    useLayoutEffect(() => {
        const dialogInput = document.querySelectorAll(".deleteDialog input")[0] as HTMLInputElement
        dialogInput.focus()
    }, [])

    function handleChange(event: ChangeEvent<HTMLInputElement>) {
        const { value } = event.currentTarget
        setValue(value?.toUpperCase())
    }

    function handleTimeoutChange(event: ChangeEvent<HTMLInputElement>) {
        let { value } = event.target
        value = value?.toUpperCase()
        if (validationKey.current === value) {
            setError(false)
        } else {
            setError(true)
        }

        setValue(value)
    }

    function handleKeyDown(event: KeyboardEvent<HTMLInputElement>) {
        if (event.key === "Enter") {
            const confirmButton = document.querySelector('.deleteDialog button:last-child') as HTMLButtonElement
            if (confirmButton && error === false) {
                confirmButton.click()
            }
        }
    }

    function handleConfirm(event: MouseEvent<HTMLButtonElement>, btnRef: any) {
        resolve({ event, btnRef })
    }
    function handleCancel() {
        DialogHandler.hide()
        reject()
    }
    return <Stack className="deleteDialog">
        <DialogTitle variant="h2" type="warning">
            {t("delete-dialog-heading-txt", { resource: t(resourceKey) })}</DialogTitle>
        <DialogContent>
            <Typography variant="body1L">
                {t("delete-dialog-txt", { resource: resourceKey })}
                <b>'{name}'</b>
            </Typography>
            <TextField
                label={t("delete-dialog-label")}
                onChange={handleChange}
                value={value}
                timeout={{
                    callback: handleTimeoutChange
                }}
                onKeyDown={handleKeyDown}
                error={error}
                helperText={error ? t("delete-dialog-delete-helper-txt", { keyword: validationKey.current }) : undefined}
            />
        </DialogContent>
        <DialogActions
            primaryBtnText={t("general-confirm")}
            primaryBtnOnClick={handleConfirm}
            primaryBtnDisabled={error === undefined ? true : error}
            secondaryBtnText={t("general-cancel")}
            secondaryBtnOnClick={handleCancel}
        />
    </Stack >
}